import React, {useState} from "react";
import classNames from "classnames";
import AnimateHeight from "react-animate-height";
import {ReactComponent as Error} from "./../../images/monochrome-icons/ic-error.svg";
import {ReactComponent as Warning} from "./../../images/monochrome-icons/ic-warning.svg";
import {ReactComponent as Success} from "./../../images/monochrome-icons/ic-success-circle.svg";
import {ReactComponent as Close} from "./../../images/monochrome-icons/ic-close.svg";
import {ReactComponent as Info} from "./../../images/monochrome-icons/ic-info-circle-thick.svg";
import buttonStyles from "./../buttons.module.scss";
import styles from "./Notification.module.scss";
import TransitionChevron from "./TransitionChevron";

export const iconTypeMapper = {
    error: { icon: Error },
    warning: { icon: Warning },
    success: { icon: Success },
    info: { icon: Info },
    urgent: { icon: Warning }
};

export default ({ type, children, moreInfoClassName, moreInfo, onClose, className, style, messageStyle, isGlobal }) => {
    const [showMore, setShowMore] = useState(false);
    const Icon = iconTypeMapper[type].icon;
    const hasMore = !!moreInfo;
    const closeable = !!onClose;

    return (
        <div className={classNames(styles["container"], styles[type], className, {[styles['global']]: isGlobal})} style={style}>
            <div className={classNames(styles["main"], {[styles["not-closeable"]]: !closeable})} style={messageStyle}>
                <Icon className={styles["type-icon"]}/>
                <div>
                    {children}
                    {hasMore && <button type="button" onClick={() => setShowMore(!showMore)} className={classNames(buttonStyles["text"], styles["show-more"])}>
                        {showMore ? "Show Less" : "Show More"}
                        <TransitionChevron isActive={showMore} className={styles['chevron']}/>
                    </button>}
                </div>
                {closeable && <button type="button" className={styles["delete-button"]} onClick={onClose}><Close/></button>}
            </div>
            <AnimateHeight
                duration={ 400 }
                easing="cubic-bezier(.25,.8,.25,1)"
                height={ showMore ? "auto" : 0 }
                contentClassName={styles['more-wrapper']}
            >
                <div className={classNames(styles["more"], {[styles["not-closeable"]]: !closeable}, moreInfoClassName)}>
                    {moreInfo}
                </div>
            </AnimateHeight>
        </div>
    );
};
